import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';

@Component({
  selector: 'app-playbook-name',
  standalone: true,
  imports: [],
  templateUrl: './playbook-name.component.html',
  styleUrl: './playbook-name.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PlaybookNameComponent {
    @Input() dataItem: IPlaybooksItemDTO;
    @Input() columnOptions: ITableColumn;
}
